/** Fix időlépéses játékciklus: stabil fizika, képkockafüggetlen viselkedés. */
export interface Loop {
  start(): void;
  stop(): void;
  readonly running: boolean;
}

export interface LoopOptions {
  /** másodperc, alapból 1/60 */
  step?: number;
  update: (dt: number) => void;
  render: (alpha: number) => void;
}

export const createLoop = (options: LoopOptions): Loop => {
  const step = options.step ?? 1 / 60;
  const maxFrame = 0.1;
  let last = 0;
  let acc = 0;
  let raf = 0;
  let running = false;

  const frame = (now: number): void => {
    if (!running) return;
    if (last === 0) last = now;
    let delta = (now - last) / 1000;
    last = now;
    if (delta > maxFrame) delta = maxFrame;
    acc += delta;

    let guard = 0;
    while (acc >= step && guard < 6) {
      options.update(step);
      acc -= step;
      guard++;
    }
    if (guard >= 6) acc = 0;

    options.render(acc / step);
    raf = requestAnimationFrame(frame);
  };

  return {
    start() {
      if (running) return;
      running = true;
      last = 0;
      acc = 0;
      raf = requestAnimationFrame(frame);
    },
    stop() {
      running = false;
      cancelAnimationFrame(raf);
    },
    get running() {
      return running;
    },
  };
};
